import * as Sentry from "@sentry/browser";
import store from "../store";

// REDUX
import ACTIONS from "../actions/types";

// TYPES
import {
  isObject,
  isArray,
  isNumber,
  isString,
  isFunction,
  isBoolean,
  isDate,
  isRegExp,
  isNull,
} from "../types/checkTypes";

const validateData = (errLocation, axiosRes, validationData) => {
  const throwError = ({ errCausedBy, errorAt, propValue, valType, expectedType }) => {
    // display error popup
    store.dispatch({ type: ACTIONS.ERROR_POPUP });

    const errMsg = createErrorMsg(errCausedBy, errorAt, propValue, valType, expectedType);
    console.error(errMsg, "color:blue");
    Sentry.captureException(new Error(errMsg));
  };

  const createErrorMsg = (errCausedBy, errorAt, propValue, valType, expectedType) => {
    const errorSpecificsMsg = () => {
      if (errCausedBy === "property") {
        return `Property [${errorAt}] does not exist!`;
      }

      if (errCausedBy === "type") {
        return `Invalid type of the property [${errorAt}]!
        [${errorAt}] value is: [${propValue}] and its type is: [${valType}].
        The expected type is: [${expectedType}].`;
      }
    };

    const msg = `Error at: ${errLocation}, at propery: [${errorAt}].
    Request url is: ${axiosRes.request.responseURL}, request status is: ${axiosRes.status}
    ${errorSpecificsMsg()}
    '\n'
    VALIDATION MODEL DATA: ${JSON.stringify(validationData, null, 2)}
    '\n'
    SEVER DATA: ${JSON.stringify(axiosRes.data, null, 2)}`;

    return msg;
  };

  const validate = () => {
    let data = axiosRes.data;
    let valid = true;

    if (!data || !isObject(data)) {
      throwError({
        errCausedBy: "both",
        errorAt: `data in axios res object`,
        propValue: data,
        valType: typeof data,
        expectedType: "object",
      });
      return false;
    }

    // recursive function to check the types
    const validateProperties = (validationData, realData) => {
      // iterate trough each key in the validationData
      for (let key in validationData) {
        if (!realData) {
          throwError({
            errCausedBy: "property",
            errorAt: key,
            propValue: realData,
            valType: typeof realData,
          });
          return false;
        }

        // if key exists in the real data
        if (key in realData) {
          // check the type of that key
          const isTypeValid = checkType(validationData[key].type, realData[key]);

          // if type is valid
          if (isTypeValid) {
            // check if property has its own data
            if (validationData[key].contains) {
              // check if the mocked property is array
              if (validationData[key].type === "array") {
                // if its array pass first object
                if (realData[key].length === 0) {
                  return true;
                } else {
                  validateProperties(validationData[key].contains, realData[key][0]);
                }
              } else {
                validateProperties(validationData[key].contains, realData[key]);
              }
            }
          }
          // if type is invalid
          else {
            throwError({
              errCausedBy: "type",
              errorAt: key,
              propValue: realData[key],
              valType: typeof realData[key],
              expectedType: validationData[key].type,
            });
            valid = false;
            break;
          }
        }
        // if key does not exist in the real data
        else {
          throwError({ errCausedBy: "property", errorAt: key });
          valid = false;
          break;
        }
      }
    };
    validateProperties(validationData, data);

    return valid;
  };

  const checkType = (type, data) => {
    switch (type) {
      case "string":
        return isString(data);
      case "number":
        return isNumber(data);
      case "object":
        return isObject(data);
      case "array":
        return isArray(data);
      case "function":
        return isFunction(data);
      case "boolean":
        return isBoolean(data);
      case "date":
        return isDate(data);
      case "regex":
        return isRegExp(data);
      case "null":
        return isNull(data);
      case "any":
        return true;

      default:
        return false;
    }
  };

  return validate();
};

export default validateData;
